function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M68.25 21.75H5.25V68.25H68.25V21.75Z",
  stroke: "#718096",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.75 12.75H57.75",
  stroke: "#718096",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M24.75 3.75H48.75",
  stroke: "#718096",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M50.25 35.25V41.25H23.25V35.25",
  stroke: "#718096",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var SvgDrawer = function SvgDrawer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDrawer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/drawer.7fc8e293.svg";
export { ForwardRef as ReactComponent };